import React, { Component } from 'react';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import API from '../../api/api';
import './admin-gallery-images.css';
import LinearProgress from '@material-ui/core/LinearProgress';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import MultiImageUpload from '../../components/MultiImageUpload/MultiImageUpload';
import { Box, Typography } from '@material-ui/core';

const garageApi = new API();

class AdminGalleryImagesDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      galleryId: props.galleryId || null,
      images: [],
      loading: true,
      busy: false,
      snackBar: false,
      snackBarMessage: '',
      snackBarSeverity: 'success',
    };
  }

  componentDidMount() {
    if (this.state.galleryId) this.loadImages();
    else this.setState({ loading: false });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.galleryId !== this.props.galleryId) {
      this.setState({ galleryId: this.props.galleryId || null }, () => {
        if (this.state.galleryId) this.loadImages();
        else this.setState({ loading: false, images: [] });
      });
    }
  }

  loadImages() {
    if (!this.state.galleryId) return;
    this.setState({ loading: true });

    garageApi.endpoints.gallery
      .getImages(this.state.galleryId)
      .then((response) => {
        const images = Array.isArray(response.data)
          ? response.data
          : response.data?.results || [];
        this.setState({ images, loading: false });
      })
      .catch(() => {
        // Fallback: Galerie-Objekt mit images
        garageApi.endpoints.gallery
          .getOne({ id: this.state.galleryId })
          .then((res) => {
            const images = Array.isArray(res.data?.images) ? res.data.images : [];
            this.setState({ images, loading: false });
          })
          .catch(() => this.setState({ images: [], loading: false }));
      });
  }

  handleImagesChange = async (nextImages) => {
    const prevIds = new Set(this.state.images.map((img) => img.id));
    const added = nextImages.filter((img) => img?.id && !prevIds.has(img.id));
    const removed = this.state.images.filter(
      (img) => img?.id && !nextImages.some((n) => n.id === img.id)
    );

    this.setState({ images: nextImages, busy: true });

    try {
      if (added.length && this.state.galleryId) {
        await garageApi.endpoints.gallery.addImages(
          this.state.galleryId,
          added.map((img) => img.id),
          null
        );
        this.showSnackBar(
          added.length === 1 ? 'Bild hinzugefügt' : `${added.length} Bilder hinzugefügt`,
          'success'
        );
      }

      for (const img of removed) {
        await garageApi.endpoints.gallery.removeImage(this.state.galleryId, img.id);
      }
      if (removed.length) {
        this.showSnackBar(
          removed.length === 1 ? 'Bild entfernt' : `${removed.length} Bilder entfernt`,
          'success'
        );
      }

      this.loadImages();
    } catch (error) {
      this.showSnackBar(
        error?.response?.data?.message || error.message || 'Aktion fehlgeschlagen',
        'error'
      );
      this.loadImages();
    } finally {
      this.setState({ busy: false });
    }
  };

  showSnackBar(message, severity = 'success') {
    this.setState({
      snackBar: true,
      snackBarMessage: message,
      snackBarSeverity: severity,
    });
  }

  closeSnackBar(event, reason) {
    if (reason === 'clickaway') return;
    this.setState({ snackBar: false });
  }

  render() {
    const { loading, images, busy, snackBar, snackBarMessage, snackBarSeverity } = this.state;

    return (
      <div>
        <DialogTitle id="form-dialog-title">Galerie-Bilder</DialogTitle>
        {(loading || busy) && <LinearProgress color="primary" />}
        <DialogContent className="spg-gallery-dialog">
          <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
            Bilder hierher ziehen oder auswählen — sie werden sofort der Galerie hinzugefügt.
          </Typography>

          <MultiImageUpload
            type="gallery"
            name="Gallery"
            label="Bilder hierher ziehen oder klicken"
            maxSizeMB={64}
            images={images}
            onChange={this.handleImagesChange}
            onError={() => this.showSnackBar('Upload fehlgeschlagen', 'error')}
          />

          {!loading && images.length === 0 && (
            <Box className="spg-gallery-dialog__empty">
              <Typography variant="body2" color="textSecondary">
                Noch keine Bilder in dieser Galerie.
              </Typography>
            </Box>
          )}

              {images.length > 0 && (
            <Typography
              variant="caption"
              color="textSecondary"
              display="block"
              style={{ marginTop: 12 }}
            >
              {images.length} {images.length === 1 ? 'Bild' : 'Bilder'} in der Galerie
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <div className="p-line-end">
            <Button
              variant="contained"
              color="primary"
              onClick={(e) => {
                e.stopPropagation();
                this.props.close();
              }}
            >
              Fertig
            </Button>
          </div>
        </DialogActions>
        <Snackbar
          open={snackBar}
          autoHideDuration={4000}
          onClose={this.closeSnackBar.bind(this)}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={this.closeSnackBar.bind(this)}
            severity={snackBarSeverity}
          >
            {snackBarMessage}
          </MuiAlert>
        </Snackbar>
      </div>
    );
  }
}

export default AdminGalleryImagesDialog;
